module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "floatingNotificationsHolder"
  }, _vm._l((_vm.floatingNotifications), function(notification, index) {
    return (_vm.showFloatNotificationCondition(notification, index)) ? _c('div', {
      staticClass: "infoCard shadowed fs-small mt-2 radius-normal border-medium pointer",
      on: {
        "mouseover": function($event) {
          return _vm.mouseOver(notification)
        },
        "mouseleave": function($event) {
          return _vm.mouseLeave(notification)
        }
      }
    }, [_c('timed-bar', {
      staticClass: "mb-1",
      attrs: {
        "pause": notification.floatHovering
      },
      on: {
        "done": function($event) {
          return _vm.closeNotification(notification)
        }
      }
    }), _vm._v(" "), _c('notification', {
      staticClass: "pt-1",
      attrs: {
        "notification": notification,
        "options": _vm.notificationOptions
      },
      on: {
        "closeNotification": function($event) {
          return _vm.closeNotification(notification)
        }
      }
    })], 1) : _vm._e()
  }), 0)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-b2f5c1d2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2f5c1d2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/notifications/floatingNotifications/floatingNotifications.vue
// module id = 2344
// module chunks = 0